// (function($, Site) {
//     "use strict";

// })(jQuery, Site);

"use strict";
var $ = jQuery;

function initFeatureStats() {
    $(document).ready(function () {
        $(".statistics_featured_item_stat").each(function (index) {
            var divHeight = $(this).outerHeight();
            this.style.setProperty("--featured-stats-div-height", divHeight + "px");
        });
    });
}

$(initFeatureStats);